<script setup lang="ts">
import { tv } from "tailwind-variants";

const packet = inject(keys.currentPacket);

const variants = tv({
  slots: {
    wrapper: "py-16",
    heading: "mb-14 text-center font-headline text-4xl",
    pitch: "",
    list: "",
  },
  variants: {
    theme: {
      "green-seagreen": {
        pitch: ["bg-yellow-25", "text-seagreen-40", "[&_p]:text-black-80"],
        heading: "text-seagreen-50",
      },
      "dark-red-pink": {
        pitch: ["bg-coral-50", "text-red-20", "[&_p]:text-white"],
        heading: "text-coral-5",
      },
      "blue-pink": {
        wrapper: "pb-44",
        pitch: ["border", "border-coral-pop", "text-coral-20", "[&_p]:text-white"],
        heading: "text-white",
        list: "gap-10",
      },
      "green-red": {
        pitch: ["bg-coral-5", "text-seagreen-50", "[&_p]:text-black-80"],
        heading: "text-seagreen-50",
      },
    },
    index: {
      0: {
        pitch: "lg:pl-40",
      },
      1: {
        pitch: "lg:pl-xl",
      },
      2: {
        pitch: "lg:pl-40",
      },
    },
  },
  compoundVariants: [
    {
      theme: ["green-seagreen", "dark-red-pink", "green-red"],
      class: {
        pitch: "rounded-tr-[60px]",
        list: "gap-5",
      },
    },
    {
      theme: ["green-seagreen", "dark-red-pink", "green-red"],
      index: 0,
      class: {
        pitch: "lg:rounded-tr-[160px]",
      },
    },
    {
      theme: ["green-seagreen", "dark-red-pink", "green-red"],
      index: 1,
      class: {
        pitch: "lg:rounded-r-[160px]",
      },
    },
    {
      theme: ["green-seagreen", "dark-red-pink", "green-red"],
      index: 2,
      class: {
        pitch: "lg:rounded-bl-[160px] lg:rounded-tr-none",
      },
    },
  ],
});

const classes = computed(() => variants({ theme: unref(packet)?.theme }));

const pitches = computed(() => unref(packet)?.pitches);
</script>

<template>
  <section v-if="pitches?.length" :class="classes.wrapper()">
    <div class="mx-auto">
      <h2 :class="classes.heading()">
        Tilpasset lærere — og elever
      </h2>
      <ul :class="classes.list()" class="flex flex-col lg:gap-28">
        <li v-for="(pitch, i) in pitches" :key="pitch.title">
          <PacketPitch
            v-bind="pitch"
            :class="classes.pitch({ index: i % 3 as (0 | 1 | 2) })"
            :dir="i % 2 === 0 ? 'rtl' : 'ltr'"
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<style scoped>
section > div {
  max-width: min(95%, var(--breakpoint-xl));
}
</style>
